import { type FC } from "react";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";

import { type ProductItem } from "@/views/configuration/server-settings/types";

interface ScopeCheckboxListProps {
	readonly scopes: ProductItem[];
	readonly readonly?: boolean;
	readonly onChange?: (name: string, checked: boolean) => void;
}

export const ScopeCheckboxList: FC<ScopeCheckboxListProps> = ({ scopes, readonly = false, onChange }) => {
	const handleChange = (name: string, checked: boolean) => {
		if (onChange && !readonly) {
			onChange(name, checked);
		}
	};

	return (
		<Grid display="grid" gridTemplateColumns="auto auto" gap={1}>
			{scopes.map((scope) => (
				<FormControlLabel
					key={scope.formattedScope}
					control={
						<Checkbox
							checked={scope.value}
							disabled={readonly}
							onChange={(e) => handleChange(scope.name, e.target.checked)}
							name={scope.name}
						/>
					}
					label={scope.displayName}
				/>
			))}
		</Grid>
	);
};
